import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap');

  body {
    background-color: #142d4c;
    font-family: 'Roboto Mono', monospace; /* TODO replace with Inter? */
    overflow-x: hidden;
    text-rendering: optimizeSpeed;
  }
`
